import React from 'react'
import {
  imageButton,
  imageCard,
  imageCardContentImage,
  imageChecked,
  imageRadio,
  imageRadioContainerChecked,
  imageRadioContainerUnChecked,
  imageRadioIcon,
  imageContainer,
  imageRadioLabel,
} from './ImageRow.css'
import { isCoverOnCreateFlowEnabled } from '../../../utils/features'
import { classNames } from '../../../utils/classNames'

interface ImageRowProps {
  checked: boolean
  photo: {
    name: string
    url: string
  }
  onChange: any
  index: number
}

export default function ImageRow(props: ImageRowProps) {
  const { checked, photo, onChange, index } = props

  const doChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(parseInt(e.target.value, 10))
  }

  const onClickImage = () => {
    onChange(index)
  }

  const renderImageRadioButton = () => {
    const inputId = `imageradio_${index}`

    return (
      <>
        <input
          type="radio"
          name="image"
          id={inputId}
          className={imageRadio}
          value={index}
          checked={checked}
          onChange={doChange}
        />
        <label
          className={classNames(imageContainer, imageRadioLabel)}
          htmlFor={inputId}
          data-testid={`image-row-label-${index}`}
        >
          <img
            src={photo.url}
            alt={photo.name}
            className={imageCardContentImage}
          />

          <span
            className={
              checked
                ? imageRadioContainerChecked
                : imageRadioContainerUnChecked
            }
          >
            <span aria-hidden="true" className={imageRadioIcon}>
              {/* this was stolen from pp-react, since there is no component for this */}
              {checked && (
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    r="18"
                    cy="50"
                    cx="50"
                    strokeWidth="0"
                    fill="currentColor"
                  />
                </svg>
              )}
            </span>
          </span>
        </label>
      </>
    )
  }

  const renderImageButton = () => {
    return (
      <button
        onClick={onClickImage}
        aria-label={photo.name}
        data-testid={`image-row-button-${index}`}
        className={classNames(
          imageContainer,
          imageButton,
          checked && imageChecked,
        )}
      >
        <img src={photo.url} alt="" className={imageCardContentImage} />
      </button>
    )
  }

  return (
    <div className={imageCard} data-testid="image-row">
      {isCoverOnCreateFlowEnabled()
        ? renderImageButton()
        : renderImageRadioButton()}
    </div>
  )
}
